import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 text-xs font-medium text-primary-400 mb-3">
            <i className="ri-star-line"></i>
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">平台优势</h2>
          <p className="mt-2 text-sm text-foreground-500">三大核心能力，打造极致观影体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresData.map((item) => (
            <div
              key={item.id}
              className="group p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-500/10 group-hover:bg-primary-500/15 transition-colors mb-5">
                <i className={`${item.icon} text-2xl text-primary-400`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}